module.exports = __webpack_public_path__ + "img/logo.129a8378.png";